module.exports = __webpack_public_path__ + "img/placemakers-underconstruction-event.1b903531.jpg";